

export const more = () => {

  const moreCard = document.querySelectorAll(".js-more__card");

  if ( moreCard ) {
    for(var i = 0 ; i < moreCard.length; i++){
      moreCard[i].addEventListener("click", function(){
  
        this.querySelector('.more__arrow').classList.toggle("more__arrow_open");

        this.querySelector(".more__slide").classList.toggle("more__slide_open");


        if ( this.querySelector(".more__slide").classList.contains("more__slide_open") ) {
          this.querySelector(".more__slide").style.height = this.querySelector('.content-cms').offsetHeight + 46 + "px";
        } else {
          this.querySelector(".more__slide").style.height = 0 + "px";
        }

        
  
      });
    }
  }
  

}